import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  TierPauseData,
  TierPauseCreate,
  TierPause,
} from '@models/user/tierPause.model';

@Injectable()
export class TierPauseService {
  baserHref = `${environment.apiUrl}/tier-pause`;

  constructor(private http: HttpClient) {}

  getTierPauseData(): Observable<TierPauseData> {
    const url = `${this.baserHref}/`;
    return this.http.get<TierPauseData>(url);
  }

  createTierPause(data: TierPauseCreate): Observable<TierPause> {
    const url = `${this.baserHref}`;
    return this.http.post<TierPause>(url, data);
  }

  terminateTierPause(tierPauseId: number): Observable<any> {
    const url = `${this.baserHref}/terminate`;
    return this.http.post(url, { tierPauseId });
  }

  /*  getActiveTierPause(userId): Observable<any> {
    const url = `${this.baserHref}/active?userId=${userId}`;
    return this.http.get(url);
  }

  getUpcomingTierPause(userId): Observable<any> {
    const url = `${this.baserHref}/upcoming?userId=${userId}`;
    return this.http.get(url);
  }

  getTierPauseDaysUsed(): Observable<any> {
    const url = `${this.baserHref}/days-used`;
    return this.http.get(url);
  }*/
}
